// extracted by mini-css-extract-plugin
export default {"background":"Title_background__5j0ZH","title":"Title_title__IlEm8","titleIn":"Title_titleIn__F0IhI","gradient":"Title_gradient__0UFZ3"};